<!-- 开普勒视频 -->
<template>
  <div class="keplerpat">
    <div class="title_index">
      <div class="name">共享软件工厂优势</div>
      <div class="detailed">
        <div>提供软件定制开发服务</div>
        <div style="padding-left: 28px;">灵活用人不养人</div>
      </div>
    </div>
    <div class="keplerpat_video">
      <video muted="muted" class="video" controls src="../../assets/vdo.mp4" type="video/mp4" poster="false.png"
        autoplay="autoplay" loop="-1">
        <p>你的浏览器不支持video标签.</p>
      </video>
    </div>


  </div>
</template>

<script>
// import { showNumber, packageListHomepage } from "@/api/projectSquare/xmgc";
export default {
  name: 'keplerpat',
  data() {
    return {


    };
  },
  created() { },
  methods: {

  },
};
</script>

<style scoped>
.keplerpat {
  width: 100%;
  background: linear-gradient(180deg, #DDECFF 0%, #93B7C3 100%);
  border-radius: 0px 0px 0px 0px;
  margin-top: 120px;
  padding-bottom: 120px;
}

.title_index {
  padding: 100px 0 72px 0;
}

.title_index .name {
  font-size: 72px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.9);
  line-height: 84px;
}

.title_index .detailed {
  font-size: 32px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
  line-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
}

.keplerpat_video {
  width: 1200px;
  height: 675px;
  border-radius: 32px;
  border: 4px solid #FFFFFF;
  margin: 0 auto;
  overflow: hidden;
}

video {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Lunbot/keplerpat.vue